import { phpRequest } from "./phpRequest";

export const deleteRoleAPI = (role_id, company_id) => {
  return phpRequest.delete("/roles/remove", {
    role_id,
    company_id,
  });
};
